module.exports = __webpack_public_path__ + "media/images/business/slide-arrow-next-b684daafb1c54b5240f03bd4d9348c18.svg";